import React, { createContext, useState, useContext, useEffect } from 'react';
import { Platform } from 'react-native';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(true); // Default to dark mode

  useEffect(() => {
    // Update body data attribute for CSS theme switching
    if (Platform.OS === 'web') {
      document.body.setAttribute('data-theme', isDarkMode ? 'dark' : 'light');
    }
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(prev => !prev);
  };

  const theme = {
    isDarkMode,
    toggleTheme,
    colors: {
      background: isDarkMode ? '#000000' : '#F5F5F5',
      surface: isDarkMode ? '#1a1a1a' : '#FFFFFF',
      text: isDarkMode ? '#FFFFFF' : '#000000',
      heading: isDarkMode ? '#FDFD0A' : '#d4af37',
      subheading: isDarkMode ? '#FDFD0A' : '#d4af37',
      border: isDarkMode ? '#333333' : '#E0E0E0',
      inputBackground: isDarkMode ? '#2a2a2a' : '#FFFFFF',
      inputBorder: isDarkMode ? '#3a3a3a' : '#CCCCCC',
      primary: '#d4af37',
      secondary: isDarkMode ? '#FFFFFF' : '#000000',
    },
  };

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
};

